module.exports = __webpack_public_path__ + "media/images/acuvue_card_1-013b80ebcaf7e96a942a3ab366cfedca.jpg";